import { Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <div class="login-wrapper">
      <div class="login-card">
        <div class="login-header">
          <img src="/logo.png" alt="Logo REP" class="login-logo">
          <h1>REP</h1>
          <p>Connectez-vous à votre compte</p>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="username">NOM D'UTILISATEUR</label>
            <input type="text" id="username" formControlName="username" class="form-control" placeholder="admin">
          </div>

          <div class="form-group">
            <label for="password">MOT DE PASSE</label>
            <input type="password" id="password" formControlName="password" class="form-control" placeholder="••••••••">
          </div>

          @if (errorMessage()) {
            <div class="error-container">
              {{ errorMessage() }}
            </div>
          }

          <button type="submit" [disabled]="loginForm.invalid || isLoading()" class="btn btn-primary btn-block">
            @if (isLoading()) {
              <span>Connexion en cours...</span>
            } @else {
              <span>Se connecter</span>
            }
          </button>
        </form>
      </div>
    </div>
  `,
  styles: [`
    .login-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background: linear-gradient(135deg, #3f51b5 0%, #002984 100%);
    }
    .login-card {
      background: white;
      padding: 2.5rem;
      border-radius: 12px;
      box-shadow: var(--shadow-lg);
      width: 100%;
      max-width: 400px;
    }
    .login-header {
      text-align: center;
      margin-bottom: 2rem;
    }
    .login-logo {
      width: 150px;
      height: auto;
      margin-bottom: 1.5rem;
    }
    .login-header h1 {
      margin: 0;
      color: var(--primary-color);
      font-size: 2rem;
      font-weight: 800;
      letter-spacing: -0.5px;
    }
    .login-header p {
      color: var(--text-secondary);
      margin-top: 0.5rem;
      font-size: 0.95rem;
    }
    .error-container {
      background-color: #ffebee;
      color: #c62828;
      padding: 0.75rem;
      border-radius: 4px;
      margin-bottom: 1.25rem;
      font-size: 0.85rem;
      text-align: center;
      border-left: 4px solid var(--error-color);
    }
    .btn-block {
      width: 100%;
      padding: 0.85rem;
      font-size: 1rem;
      margin-top: 1rem;
    }
  `]
})
export class LoginComponent {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  loginForm = this.fb.group({
    username: ['', [Validators.required]],
    password: ['', [Validators.required]]
  });

  isLoading = signal(false);
  errorMessage = signal<string | null>(null);

  onSubmit() {
    if (this.loginForm.valid) {
      this.isLoading.set(true);
      this.errorMessage.set(null);

      this.authService.login(this.loginForm.value).subscribe({
        next: () => {
          const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
          this.router.navigateByUrl(returnUrl);
        },
        error: (err) => {
          this.isLoading.set(false);
          if (err.status === 0 || err.status >= 500) {
            this.errorMessage.set('Erreur Serveur');
          } else {
            const backendMessage =
              err?.error?.message ||
              err?.error?.error ||
              (typeof err?.error === 'string' ? err.error : null);
            this.errorMessage.set(backendMessage || 'Identifiant ou mot de passe incorrect');
          }
          console.error(err);
        }
      });
    }
  }
}
